/** ~1 mile public approximate area on Leaflet maps (red, no center pin). */
export const APPROX_AREA_CIRCLE_PATH = {
  color: 'rgba(239, 68, 68, 0.95)',
  fillColor: '#ef4444',
  fillOpacity: 0.12,
  weight: 2,
} as const;
